var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoGradient = function SvgInfoGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.015 31.909c-7.935 0-14.41-6.459-14.41-14.393 0-7.935 6.459-14.41 14.41-14.41 7.95 0 14.393 6.459 14.393 14.41 0 7.95-6.459 14.393-14.393 14.393Zm0-27.18c-7.043 0-12.787 5.728-12.787 12.787 0 7.058 5.728 12.77 12.787 12.77 7.058 0 12.77-5.728 12.77-12.77 0-7.043-5.728-12.787-12.77-12.787Zm0 19.423a.803.803 0 0 1-.812-.811v-8.032c0-.455.357-.811.812-.811.454 0 .811.356.811.81v8.033a.803.803 0 0 1-.811.811Zm0-13.306c-.666 0-1.217.552-1.217 1.217 0 .666.551 1.217 1.217 1.217.665 0 1.217-.551 1.217-1.216 0-.666-.552-1.217-1.217-1.217Z",
    fill: "url(#info-gradient_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "info-gradient_svg__a",
    x1: 3.605,
    y1: 3.106,
    x2: 32.408,
    y2: 31.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A93E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#504CCB"
  })))));
};
export default SvgInfoGradient;